import { API_INTERNAL_ENDPOINT } from './constants'
import { type schemaType } from './schema'
import { type paramsType } from './paramsSchema'

export type returnType = ApiServerResponse<schemaType>

export const serverFetch = async (params: paramsType): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/${API_INTERNAL_ENDPOINT}`

  const { data } = await useFetch(url, {
    body: params,
    method: 'POST',
    key: url,
  })

  return data.value as returnType
}

export const browserFetch = async (params: paramsType): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/${API_INTERNAL_ENDPOINT}`

  const data = await $fetch(url, {
    body: params,
    method: 'POST',
  })

  return data as returnType
}
